import { Button } from "ui/button";

import Icons from "assets";

import type { AiContentVote } from "./ai-content-feedback.types";

type AiContentVoteBlockProps = {
  selectedVote: AiContentVote | null;
  onVoteSelect: (vote: AiContentVote) => void;
};

const AiContentVoteBlock = ({ selectedVote, onVoteSelect }: AiContentVoteBlockProps) => {
  function handleLooksGoodClick() {
    onVoteSelect("looks_good");
  }

  function handleNeedsImprovementClick() {
    onVoteSelect("needs_improvement");
  }

  return (
    <div
      className="mt-3 flex w-full flex-col gap-3 overflow-hidden rounded-md border border-gray-300 px-3 pb-3 pt-2"
      data-testid="ai-content-vote-block">
      <p className="text-base font-bold leading-6 text-gray-900">How is this generated content?</p>
      <div className="flex flex-wrap gap-2.5">
        <Button
          color="inherit"
          variant={selectedVote === "looks_good" ? "contained" : "outlined"}
          size="small"
          startIcon={<Icons.ThumbsUp />}
          onClick={handleLooksGoodClick}
          aria-pressed={selectedVote === "looks_good"}>
          Looks good
        </Button>
        <Button
          color="inherit"
          variant={selectedVote === "needs_improvement" ? "contained" : "outlined"}
          size="small"
          startIcon={<Icons.ThumbsDown />}
          onClick={handleNeedsImprovementClick}
          aria-pressed={selectedVote === "needs_improvement"}>
          Needs improvement
        </Button>
      </div>
    </div>
  );
};

export default AiContentVoteBlock;
